import workspaceQuery from '../../../graphql/queries/product/GoodsReceiptLineLabelWorkspaceQuery.graphql';
import fragment from '../../../graphql/fragments/product/ReceiptLabelFragment.graphql';
import instanceQuery from '../../../graphql/queries/purchases/PurchaseOrderDocumentQuery.graphql';

import generateMutation from '../../../graphql/mutations/product/ReceiptLabelGenerateMutation.graphql';
import generateRangeMutation from '../../../graphql/mutations/product/ReceiptLabelGenerateRangeMutation.graphql';
import reprintMutation from '../../../graphql/mutations/product/ReceiptLabelReprintMutation.graphql';

import * as printFunctions from '../../../actions/product/ReceiptLabelAction';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const GoodsReceiptLineLabel: EntityType = {
  type: 'GoodsReceiptLineLabel',
  title: 'Goods Receipt Label',
  formTitle: 'Print Goods Receipt Labels',
  workspaceUrl: '/Product/GoodsReceiptLabel/Workspace/',
  workspace: workspaceQuery,
  generate: generateMutation,
  instance: instanceQuery,
  generateRange: generateRangeMutation,
  reprint: reprintMutation,
  fragment,
  printFunctions: printFunctions,
  actions: [],
  configuration: {
    title: 'Receipt Label',
    reportType: ReportType.ReceiptLabel,
    field: 'receiptLabelDocumentDefault',
  },
  screenReference: 'GOODS_RECEIPT_LINE_LABEL',
};

export default GoodsReceiptLineLabel;
